export default "__VITE_ASSET__CWr0zb3Z__"